import { ContactRequest } from "../Types/EmailContactRequest";
import { EmailListEntryDto } from "../Types/EmailListEntryDto";

import {
  apiPublicRawGet,
  apiPublicRawDelete,
  apiPublicRawPost
} from "./apiClient";

/* ============================================================
   PUBLIC — Send contact form
============================================================ */
export async function SendContactRequest(request: ContactRequest): Promise<void> {
  try {
    const res = await apiPublicRawPost(`/EmailList/contact`, request);
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }
  } catch (err) {
    console.error("Failed to send contact request", err);
    throw new Error("Failed to send contact request");
  }
}

/* ============================================================
   PUBLIC — Newsletter sign-up
============================================================ */
const SendEmailEntryForm = async (
  emailListEntry: EmailListEntryDto
): Promise<boolean> => {
  try {
    const res = await apiPublicRawPost(`/EmailList`, emailListEntry);
    return res.ok;
  } catch (err) {
    console.error("SendEmailEntryForm error:", err);
    return false;
  }
};

/* ============================================================
   PUBLIC — Validate newsletter subscription link
============================================================ */
const ValidadeEntry = async (searchParam: string): Promise<boolean> => {
  try {
    const res = await apiPublicRawGet(`/EmailList?id=${searchParam}`);
    return res.ok;
  } catch (err) {
    console.error("ValidadeEntry error:", err);
    return false;
  }
};

/* ============================================================
   PUBLIC — Unsubscribe from newsletter
============================================================ */
const UnsubscribeFromNewslist = async (
  searchParam: string
): Promise<boolean> => {
  try {
    const res = await apiPublicRawDelete(`/EmailList?id=${searchParam}`);
    return res.ok;
  } catch (err) {
    console.error("Unsubscribe error:", err);
    return false;
  }
};

/* ============================================================
   EXPORT
============================================================ */
export const EmailList = {
  SendEmailEntryForm,
  ValidadeEntry,
  UnsubscribeFromNewslist,
  SendContactRequest
};
